module.exports = "div.icon img {\n    width: 65%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/sidebar/sidebar.component.css
// module id = ./src/app/sidebar/sidebar.component.css
// module chunks = main